import * as React from "react";
import * as Big from "big.js";
import {
    HandHistoryEvent,
    PlayerBestHand,
    HistoricHand,
    PlayerCardsDealt,
    TableCardsDealt,
    GameCard,
    PlayerAction,
    Player,
    PlayerCardsExposed,
    Results,
    HandResult,
    PlayerBestLowHand
} from "../../../../generated/protocol";

export class CardUtils {
    static getCardsFromSeat(hand: HistoricHand, seat: Player): GameCard[] {
        if (!seat) {
            return [];
        }
        return CardUtils.getCardsFromHand(hand, seat.playerId);
    }

    static isHighlightSeat(hand: HistoricHand, playerId: number): boolean {
        if (typeof playerId == undefined) {
            return false;
        }
        let bestHand = CardUtils.getBestHandForPlayer(hand, playerId);
        if (bestHand) {
            return true;
        }
        console.log("Hightlight results ", hand.results);
        var resultsForPlayer = CardUtils.getResultsForPlayer(hand.results, playerId);
        if (resultsForPlayer) {
            return resultsForPlayer.totalWin > 0;
        }
        return false;
    }

    static isExcludeAction(action: string) {
        return ["MUCK_CARDS", "SHOW_CARDS", "SMALL_BLIND", "BIG_BLIND"].indexOf(action) != -1
    }

    static getLastActionForPlayer = (hand: HistoricHand, playerId: number): PlayerAction => {
        let search = true;
        return hand.events.concat().reverse().find((e => {
            if (search == true && e.type == "PlayerAction") {
                let playerAction: PlayerAction = e;
                if (playerAction.playerId == playerId && !CardUtils.isExcludeAction(playerAction.action)) {
                    return true;
                }
            } else if (e.type == "TableCardsDealt") {
                search = false;
            }
        }));
    };

    static calculateTotalPot(results: Results): string {
        if (!results) {
            return "0";
        }
        let total = new Big(0);
        for (var x in results.results) {
            console.log("FOUND RESULT ", results.results[x]);
            let res: HandResult = results.results[x];
            total = total.plus(new Big(res.totalBet));
        }
        return total.toString();
    }

    static getResultsForPlayer(results: Results, playerId: number): HandResult {
        if (!results || !results.results) {
            return undefined;
        }
        return results.results["" + playerId];

    }

    static getBestHandForPlayer(hand: HistoricHand, playerId: number): PlayerBestHand {
        let playerBestHand: HandHistoryEvent = hand.events.find(e => {
            if (e.type == "PlayerBestHand") {
                let bestHand: PlayerBestHand = e;
                if (bestHand.playerHand.playerId == playerId) {
                    return true;
                }
            }
            return false;
        });

        return playerBestHand as PlayerBestHand;
    }

    static getCardsFromHand(hand: HistoricHand, playerId: number): GameCard[] {
        if (!hand.events) {
            return [];
        }
        let cards = [];
        hand.events.forEach((e: HandHistoryEvent) => {
            if (e.type == "PlayerCardsDealt") {
                let pcd: PlayerCardsDealt = e;
                if (pcd.playerId == playerId) {
                    cards = cards.concat(pcd.cards.concat());
                }
            }
        });
        var discards = CardUtils.getDiscardsFromHand(hand, playerId);
        console.log("DISCARDED CARDS for player " + playerId, discards)

        cards = cards.filter((c: GameCard) => {
            let isCardDiscarded = discards.some((discard: number) => {
                return discard == c.id;
            });

            return isCardDiscarded != true;
        });
        return cards;
    }

    static getDiscardsFromHand(hand: HistoricHand, playerId: number): number[] {
        if (!hand.events) {
            return [];
        }
        let cards = [];
        hand.events.forEach((e: HandHistoryEvent) => {
            if (e.type == "PlayerAction") {
                let action: PlayerAction = e;
                if (action.playerId == playerId && action.action == "DISCARD" && action.cards) {
                    cards = cards.concat(action.cards);
                }
            }
        });
        return cards;
    }

    static getCommunityCardsFromHand(hand: HistoricHand): GameCard[] {
        if (!hand.events) {
            return [];
        }
        let cards = [];
        hand.events.forEach((e: HandHistoryEvent) => {
            if (e.type == "TableCardsDealt") {
                let tcd: TableCardsDealt = e;
                cards = cards.concat(tcd.cards);
            }
        });
        return cards;
    }

    static calculateNrOfDecimals(number: number) {
        return new Big(number).toString().replace(/[0-9]+\./, "").length;

    }

    static getCards(cards) {
        var cardElems = [];
        cards.forEach((c: GameCard) => {
            let suit = c.suit.substr(0, 1).toLowerCase();
            if (suit == "*") {
                cardElems.push(
                    <span key={c.id} className="community-card poker-card">
                                    <span className={"suit-icon-j"}></span>
                                </span>
                );
            } else {
                let rank = CardUtils.getRank(c.rank).toLowerCase();
                cardElems.push(
                    <span key={c.id} className={"community-card poker-card " + suit}>
                        <span className="card-str">{rank.toUpperCase()}</span><span
                        className={"suit-icon-" + suit}></span>
                    </span>
                );
            }
        });

        return cardElems;
    }

    static getPhaseByVariant(phase: number, variant: string) {
        if (variant == "TEXAS_HOLDEM" || variant == "TEXAS_HOLDEM_JOKER" || variant == "OMAHA" || variant == "CRAZY_PINEAPPLE") {
            if (phase == 0) {
                return "Pre-flop";
            } else if (phase == 1) {
                return "Flop"
            } else if (phase == 2) {
                return "Turn"
            } else if (phase == 3) {
                return "River"
            }
        }
        if (variant == "FOUR_CARD_21" || variant == "FOUR_CARD_21_BO7") {
            return "Card Played";
        }
        if (variant == "HOLDEM_21_RUSH" && phase != 1) {
            return "Hit";
        }
        return "Table Cards Dealt";
    }

    static getFinalHand(events: HandHistoryEvent[], playerId): GameCard[] {
        var event = events.find((e) => {
            if (e.type == "PlayerBestHand" && (e as PlayerBestHand).playerHand.playerId == playerId) {
                return true;
            }
        })
        if (event && event.type == "PlayerBestHand" && (event as PlayerBestHand).bestHandCards) {
            return (event as PlayerBestHand).bestHandCards;
        } else {
            return [];
        }
    }


    static getFinalLowHand(events: HandHistoryEvent[], playerId): GameCard[] {
        var event = events.find((e) => {
            if (e.type === "PlayerBestLowHand" && (e as PlayerBestHand).playerHand.playerId == playerId) {
                return true;
            }
        })
        if (event && event.type === "PlayerBestLowHand" && (event as PlayerBestLowHand).cards) {
            return (event as PlayerBestLowHand).cards;
        } else {
            return;
        }
    }

    static getCard(card, id) {
        var suit, rank;
        if (card.suit == null || card.rank == null) {
            suit = "back";
            rank = ""
        } else {
            suit = card.suit[0].toLowerCase();
            rank = CardUtils.getRank(card.rank);
        }


        var cardStr = rank + suit
        if (cardStr == "**") {
            suit = "joker";
            return (
                <span key={id} className={'log-card ' + suit}>
                    <span className={"suit-icon-" + suit}></span>
                </span>
            );
        }
        return (
            <span key={id} className={'log-card ' + suit}>
                <span className="card-str">{rank}</span>
                <span className={"suit-icon-" + suit}></span>
            </span>
        )
    }

    static getCardString(card: GameCard): string {
        if (card.rank as string == "*") {
            return "joker";
        } else {
            return CardUtils.getRank(card.rank).toLowerCase() + CardUtils.getSuit(card.suit);
        }
    }

    static getSuit(suit) {
        switch (suit) {
            case "CLUBS":
                return "c";
            case "DIAMONDS":
                return "d";
            case "HEARTS" :
                return "h";
            case "SPADES":
                return "s";
        }
    }

    static getRank(rank) {
        switch (rank) {
            case "TWO":
                return "2";
            case "THREE":
                return "3";
            case "FOUR":
                return "4";
            case "FIVE":
                return "5";
            case "SIX":
                return "6";
            case "SEVEN":
                return "7";
            case "EIGHT":
                return "8";
            case "NINE":
                return "9";
            case "TEN":
                return "T";
            case "JACK":
                return "J";
            case "QUEEN":
                return "Q";
            case "KING":
                return "K";
            case "ACE":
                return "A";

        }
    }


    static getNrOfDecimals(hand: HistoricHand) {
        let results = hand.results;
        let decimals = 0;
        if (results && results.results) {
            for (let x in results.results) {
                var nrOfDecimals = CardUtils.calculateNrOfDecimals(results.results[x].netWin);
                if (decimals < nrOfDecimals) {
                    decimals = nrOfDecimals;
                }
            }
        }
        if (hand.seats) {
            hand.seats.forEach(s => {
                if (decimals < CardUtils.calculateNrOfDecimals(s.initialBalance)) {
                    decimals = decimals;
                }
            });
        }

        return decimals;
    }
}


// WEBPACK FOOTER //
// ./src/app/ui/poker/history/CardUtils.tsx